export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const arrowUp = require('../assets/arrow-up.png')
export const arrowDown = require('../assets/arrow-down.png')
